import api from "./client";

export async function listShifts() {
  const res = await api.get("/shifts");
  return res.data.data;
}

export async function createShift(payload) {
  const res = await api.post("/shifts", payload);
  return res.data.data;
}

export async function updateShift(id, payload) {
  const res = await api.put(`/shifts/${id}`, payload);
  return res.data.data;
}

export async function deleteShift(id) {
  const res = await api.delete(`/shifts/${id}`);
  return res.data.data;
}
